module.exports = __webpack_public_path__ + "img/closeIcon.bce1c649.svg";